import { render } from "./HeroiconsOutlineArrowNarrowRight.vue?vue&type=template&id=78fec2af"
const script = {}

import exportComponent from "/home/fran/Desarrollo/soyasi/ebim-crm/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineArrowNarrowRight.vue"]])

export default __exports__